import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["container"]

  connect() {
    if (this.hasContainerTarget) {
      this.scheduleScroll()
    } else {
      setTimeout(() => this.scheduleScroll(), 100)
    }
  }

  disconnect() {
    // クリーンアップ処理（現在は不要）
  }

  scheduleScroll() {
    this.performScroll()
    
    setTimeout(() => this.performScroll(), 100)
    setTimeout(() => this.performScroll(), 300)
    setTimeout(() => this.performScroll(), 500)
    
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        this.performScroll()
      })
    })
  }

  performScroll() {
    if (!this.hasContainerTarget) {
      return
    }

    const container = this.containerTarget
    const table = container.querySelector('table')
    const headers = container.querySelectorAll('th[data-month]')
    
    if (!table || headers.length === 0) {
      return
    }

    const currentMonth = new Date().getMonth() + 1
    const currentMonthHeader = container.querySelector(`th[data-month="${currentMonth}"]`)
    
    if (currentMonthHeader) {
      const headerPosition = currentMonthHeader.offsetLeft
      const containerWidth = container.clientWidth
      const containerScrollWidth = container.scrollWidth
      
      // レイアウトが未完了の場合はスキップ
      if (headerPosition === 0 && currentMonth > 1) {
        return
      }
      
      // スクロールが必要かチェック
      if (containerScrollWidth <= containerWidth) {
        return
      }
      
      // 今月を一番左に表示する
      const scrollPosition = Math.max(0, headerPosition - 20)
      
      container.scrollTo({
        left: scrollPosition,
        behavior: 'smooth'
      })
    }
  }
}
